import * as React from "react";
import { cn } from "../lib/utils";

// "sm" is for dense contexts (compact list rows, inline form grids) where the
// default track/thumb reads as oversized next to text-xs/icon-sized siblings.
const SIZES = {
  default: { track: "h-6 w-11", thumb: "h-5 w-5", translateOn: "translate-x-5" },
  sm: { track: "h-4 w-7", thumb: "h-3 w-3", translateOn: "translate-x-3" },
};

const Switch = React.forwardRef(
  ({ className, checked, onCheckedChange, size = "default", ...props }, ref) => {
    const s = SIZES[size] || SIZES.default;
    return (
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        ref={ref}
        className={cn(
          "peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
          s.track,
          checked
            ? "bg-primary"
            : "bg-background-elevated",
          className
        )}
        onClick={() => onCheckedChange?.(!checked)}
        {...props}
      >
        <span
          className={cn(
            "pointer-events-none block rounded-full bg-[var(--c-surface-ffffff)] shadow-lg ring-0 transition-transform",
            s.thumb,
            checked ? s.translateOn : "translate-x-0"
          )}
        />
      </button>
    );
  }
);
Switch.displayName = "Switch";

export { Switch };
